import { getStoreDetailByStoreNumber } from "@/helpers/storeLocatorHelper";
import {
  useAppDispatch,
  useAppSelector,
  useEffect,
  useState,
} from "@/utils/hooks/reactUseCustomHooks";
import { RootState } from "@/utils/redux/store";
import { IListStores } from "@/utils/redux/storeLocator";
import { clearFilters } from "../redux/productsListing";
import { ALGOLIA_INDEXES } from "@/services/algolia/config";

export const useStoreDetails = () => {
  const [storeID, setStoreID] = useState<string>("");
  const [storeRegion , setStoreRegion]=useState<string>("");
  const [defaultRegion, setDefaultRegion] = useState<string>("")
  const dispatch = useAppDispatch(); 

  const selectedStore = useAppSelector(
    (state: RootState) => state.selectedStore.data as IListStores
  );

  const getStore = async () =>{
   const getDefaultStore = await getStoreDetailByStoreNumber(
    process.env.NEXT_PUBLIC_DEFAULT_STORE_NUMBER
    
  );
  setDefaultRegion(getDefaultStore?.region[0])
}

  useEffect(() => {
    try {
    void getStore()
    if(selectedStore?.storeNumber){
      setStoreID(selectedStore?.storeNumber?.toString() ?? process.env.NEXT_PUBLIC_DEFAULT_STORE_NUMBER);
      setStoreRegion(selectedStore?.region?.[0] ?? defaultRegion );
      // dispatch(clearFilters())
    }
    } catch (error) {
      console.error("Invalid JSON in localStorage:", error);
      setStoreID("");
      setStoreRegion("")
    }
  }, [selectedStore]);

  return {storeID,storeRegion};
};
